import {imageBaseUrl} from "config";

enum ProductCode {
    CHOTA_LOAN_CL_TOPUP = "CHOTA_LOAN::CL_TOPUP",
};
export const preApprovedBanner = {
    [ProductCode.CHOTA_LOAN_CL_TOPUP] : `${imageBaseUrl}/img/loan-topup-mob.png`,
};
